import { observer } from "mobx-react";
import styles from "./reviews.module.scss";
import { Button } from "@mui/material";
import { styled as muiStyled } from "@mui/material/styles";
import WaitingReview from "./components/waitingReview";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import React from "react";
import { sendPv, sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25336";
import { useTranslation } from "@/i18n/client";
const commonBtnStyles = {
  width: "174px",
  lineHeight: "32px",
  padding: 0,
  cursor: "pointer",
  fontSize: "14px",
};
const ReviewDetailBtn = muiStyled(Button)(() => ({
  ...commonBtnStyles,
  border: "1px solid rgba(136, 139, 148, 1)",
  // backgroundColor: '#999',
  color: "rgba(26, 26, 26, 1)",
  "&:hover": {
    background: "none",
    boxShadow: "none",
  },
}));

const ContinueShoppingBtn = muiStyled(Button)(() => ({
  ...commonBtnStyles,
  color: "#fff",
  background: "linear-gradient(90deg, #FF475D 0%, #FF0F23 100%)",
  // backgroundColor: '#999',
  "&:hover": {
    background: "linear-gradient(90deg, #FF475D 0%, #FF0F23 100%)",
    boxShadow: "none",
  },
}));
const ReviewResult = observer(() => {
  const navigate = useNavigate();

  const goReviewDetail = () => {
    /** 点击事件上报-按钮点击 */
    sendClickTrack.Evaluate_CommentComplete_Btn({ button_name: "1" });
    navigate(`/profile/my-reviews?tab=1`, { replace: true });
  };

  const goHome = () => {
    /** 点击事件上报-按钮点击 */
    sendClickTrack.Evaluate_CommentComplete_Btn({ button_name: "2" });
    window.location.replace(window.location.origin);
  };

  React.useEffect(() => {
    const searchParams = new URLSearchParams(window?.location.search);
    const orderId = searchParams.get("orderId");
    /** PV-评价完成页 */
    sendPv.Evaluate_CommentComplete({ orderId: orderId || "-100", commentId: "-100" });
  }, []);

  const { t } = useTranslation();
  return (
    <div className={styles.reviewResultWrapper}>
      <Helmet>
        <title>{`${t("seo.title.reviewSubmitSuccess")} | Joybuy`}</title>
        <meta name="description" content={t("seo.description.reviewSuccess")} />
      </Helmet>
      <div className={styles.status}>
        <div className={styles.iconSuccess}>{t("review.SubmittedSuccess")}</div>
        <div className={styles.btnWrapper}>
          <ReviewDetailBtn
            exptag={"exp|" + EXPOSURE_RECORD.Evaluate_CommentComplete_Btn_Expo}
            data-exptag-json-param={JSON.stringify({ button_name: "1" })}
            data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
            onClick={goReviewDetail}
          >
            {t("profile.breadCrumb.myReviews")}
          </ReviewDetailBtn>
          <ContinueShoppingBtn
            exptag={"exp|" + EXPOSURE_RECORD.Evaluate_CommentComplete_Btn_Expo}
            data-exptag-json-param={JSON.stringify({ button_name: "2" })}
            data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
            onClick={goHome}
          >
            {t("review.backBtn")}
          </ContinueShoppingBtn>
        </div>
      </div>
      <div className={styles.reviewsWaiting}>
        <div className={styles.h1}>{t("review.awaitingReview")}</div>
        <WaitingReview onScrollTop={() => window.scrollTo(0, 0)} pageType="reviewResult" />
      </div>
    </div>
  );
});

export default ReviewResult;
